import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FilterService, GridModule, GroupService, PageService, ResizeService, SortService } from '@syncfusion/ej2-angular-grids';
import { ChatUiComponent } from './chat-history.component';


@NgModule({
  declarations: [
    ChatUiComponent   // <-- add this
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgSelectModule,
    GridModule,
  ],
  providers: [
    PageService,
    SortService,
    ResizeService,
    FilterService,
    GroupService
  ],
  exports: [
    ChatUiComponent
  ]
})
export class ChatUiModule { }
